import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ScoresSectionComponent} from '@/app/shared/components/score-section-component/scores-section.component';
import {IThemeContent} from "@/themes/theme.interface";

// Define el tipo de datos que este componente espera recibir.
type DetailContent = IThemeContent['reports']['reportDetailComponent'];

@Component({
  selector: 'app-reporte-detalle',
  standalone: true,
  imports: [CommonModule, ScoresSectionComponent],
  templateUrl: './reporte-detalle.component.html',
  styleUrls: ['./reporte-detalle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReporteDetalleComponent {
  // Propiedad de entrada para recibir el contenido del tema desde el componente padre.
  @Input() detailContent: DetailContent | null = null;
}
